'use client'

import { Section } from '@/components/Core'
import { useGSAPMedia } from '@/hooks'
import { useStoreNavigation, useStorePageElements } from '@/store'
import { MEDIA } from '@config'
import { ScrollTrigger, gsap } from '@gsap'
import clsx from 'clsx'
import { usePathname } from 'next/navigation'
import { memo, useEffect, useRef } from 'react'

const HeaderContainer = ({ children }: { children: React.ReactNode }) => {
  //refs
  const pathname = usePathname()
  const headerRef = useRef<HTMLElement | null>(null)
  const setHeaderRef = useStorePageElements((state) => state.setHeaderRef)

  //Stores
  const { headerHidden, setHeaderHidden } = useStoreNavigation()

  useGSAPMedia({
    media: MEDIA,
    scope: headerRef.current,
    deps: [headerHidden],
    callback: (c) => {
      gsap.registerPlugin(ScrollTrigger)

      ScrollTrigger.observe({
        type: c?.conditions?.desktop ? 'wheel,touch,scroll' : 'scroll',
        onUp: () => {
          headerHidden && setHeaderHidden(false)
        },
        onDown: () => {
          headerHidden === false && setHeaderHidden(true)
        },
        tolerance: c?.conditions?.desktop ? 20 * 16 : 100
      })
    }
  })

  useEffect(() => {
    if (headerRef.current) setHeaderRef(headerRef)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerRef])

  useEffect(() => {
    setHeaderHidden(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <Section
      as="header"
      ref={headerRef}
      sectionName="header"
      data-hidden={headerHidden}
      data-bg={false}
      className={clsx(
        'group/header fixed top-0 right-0 left-0 z-[1500] text-white transition-transform duration-300',
        headerHidden == true ? '-translate-y-full' : 'translate-y-0'
      )}
    >
      {children}
    </Section>
  )
}

export default memo(HeaderContainer)
